import { Route } from '@angular/router';

import { AuthGuard } from '@authcore/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

export const appRoutes: Route[] = [

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'calendar'
    },

    //temp
    //{ path: '', pathMatch : 'full', redirectTo: 'my-team' },
    //{ path: '', pathMatch : 'full', redirectTo: 'new-booking' },
    //{ path: '', pathMatch : 'full', redirectTo: 'new-booking/choose/ff56c654-23a0-e611-86f2-06abee156f45' },

    // for local dev
    {
        path: 'employee/v1',
        pathMatch: 'prefix',
        redirectTo: 'calendar'
    },

    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: 'launch',       loadChildren: () => import('app/modules/pages/launch/launch.routes') },
        ]
    },

    {
        path: '',
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: { layout: 'main' },
        children: [
            { path: 'calendar',     loadChildren: () => import('app/modules/teams/calendar/calendar.routes') },
            { path: 'map',          loadChildren: () => import('app/modules/teams/map/map.routes') },
            { path: 'people',       loadChildren: () => import('app/modules/teams/people/people.routes') },
            { path: 'new-booking',  loadChildren: () => import('app/modules/teams/new-booking/new-booking.routes') },
            { path: 'preferences',  loadChildren: () => import('app/modules/teams/preferences/preferences.routes') }
        ]
    },

    { path: '', loadChildren: () => import('@auth/routes') },

    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '404',          loadChildren: () => import('app/modules/pages/error/error-404/error-404.routes') },
            { path: '500',          loadChildren: () => import('app/modules/pages/error/error-500/error-500.routes') },

            // 404 & Catch all
            { path: '404',          loadChildren: () => import('app/modules/pages/error/error-404/error-404.routes') },
        ]
    },

    { path: '**', redirectTo: '404' },
];
